<div class="dalog-header-cust">
    <h2>{{data?.action | titlecase}} Travel Document</h2>
    <button (click)="
              closeNav()" type="button" class="btn-cust-close">
        <i class="icon-close"></i>
    </button>
</div>
<div class="dialog-body" [formGroup]="formGroup">
    <div class="form-wrap">
        <div class="upload-row-wrap">
            <div class="upload-section">
                <label>Front</label>
                <div class="upload-image-wrap" [class.is-invalid]="!Global.isInputValid(formGroup, 'documentData')">
                    @if (formGroup.value?.fileName) {
                    <p class="file-selected">
                        {{ formGroup.value?.fileName ?? "File Selected" }}
                    </p>
                    <a matTooltip="Clear" (click)="clear()" class="remove-file"><mat-icon>close</mat-icon></a>
                    }@else {
                    <img src="assets/images/upload.svg" class="img-fluid" alt="" />
                    <input accept=".pdf, .xls, .xlsx,.png, .jpeg" (change)="
                Global.onFileUploadedToBase64(
                  formGroup,
                  $event,
                  'documentData',
                  toastr,
                  [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'image/jpeg',
                    'image/png'
                  ],
                  'fileName'
                )
              " type="file" />
                    }
                </div>
            </div>
            <div class="upload-section">
                <label>Back</label>
                <div class="upload-image-wrap" [class.is-invalid]="!Global.isInputValid(formGroup, 'documentDataBack')">
                    @if (formGroup.value?.fileNameBack) {
                    <p class="file-selected">
                        {{ formGroup.value?.fileNameBack ?? "File Selected" }}
                    </p>
                    <a matTooltip="Clear" (click)="clear(true)" class="remove-file"><mat-icon>close</mat-icon></a>
                    }@else {
                    <img src="assets/images/upload.svg" class="img-fluid" alt="" />
                    <input accept=".pdf, .xls, .xlsx,.png, .jpeg" (change)="
                Global.onFileUploadedToBase64(
                  formGroup,
                  $event,
                  'documentDataBack',
                  toastr,
                  [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'image/jpeg',
                    'image/png'
                  ],
                  'fileNameBack'
                )
              " type="file" />
                    }
                </div>
            </div>
        </div>
        <div class="form-group">
            <label>DOC TYPE@if (Global.isInputRuleAvailable(formGroup, 'docType',
                'required')) { <span class="text-danger">*</span>}</label>
            <ng-select formControlName="docType" [clearable]="false" (change)="onDocTypeChange()" placeholder="Select Document Type"
                [class.is-invalid]="!Global.isInputValid(formGroup, 'docType')" aria-label="Default select example">
                <ng-option value="PAN">PAN</ng-option>
                <ng-option value="AADHAAR">AADHAAR</ng-option>
                <ng-option value="EPIC">EPIC</ng-option>
                <ng-option value="OTHERS">OTHERS</ng-option>
            </ng-select>
            @if (formGroup.value.docType=="OTHERS") {
            <input type="text" class="form-control mt-2" placeholder="Type Here" formControlName="othersName"
                [class.is-invalid]="!Global.isInputValid(formGroup, 'othersName')" />
            }
        </div>
        <div class="form-group">
            <label>DOC NUMBER@if (Global.isInputRuleAvailable(formGroup, 'docNumber',
                'required')) { <span class="text-danger">*</span>}</label>
            <input type="text" class="form-control" placeholder="Type Here" formControlName="docNumber"
                [class.is-invalid]="!Global.isInputValid(formGroup, 'docNumber')" />
        </div>
        <div class="form-group">
            <label>ISSUED ON@if (Global.isInputRuleAvailable(formGroup, 'issuedOn',
                'required')) { <span class="text-danger">*</span>}</label>
            <input class="form-control" type="date" formControlName="issuedOn"
                [class.is-invalid]="!Global.isInputValid(formGroup, 'issuedOn')" />
        </div>
        <div class="form-group">
            <label>VALID TILL@if (Global.isInputRuleAvailable(formGroup, 'validTill',
                'required')) { <span class="text-danger">*</span>}</label>
            <input class="form-control" type="date" formControlName="validTill"
                [class.is-invalid]="!Global.isInputValid(formGroup, 'validTill')" />
        </div>
    </div>
    <div class="dialog-footer">
        <button (click)="resetForm()" class="btn-danger py-2 px-4">
            <i class="fa fa-times" aria-hidden="true"></i> Cancel
        </button>
        <button (click)="saveDoc()" class="btn-success py-2 px-4">
            <i class="fa fa-check" aria-hidden="true"></i> {{data?.action | titlecase}}
        </button>
    </div>
</div>
<!-- <div class="table-responsive mb-3" [formGroup]="formGroup" data-aos="fade-down">
    <table class="table">
        <tr>
            <th rowspan="2" colspan="1" class="fit-wdth">
                <p class="text-center">FRONT</p>
                <div class="row-img choose-file" [class.is-invalid]="!Global.isInputValid(formGroup, 'documentData')">
                    @if (formGroup.value?.fileName) {
                    <p class="file-selected">
                        {{ formGroup.value?.fileName ?? "File Selected" }}
                    </p>
                    <a matTooltip="Clear" (click)="clear()" class="remove-file"><mat-icon>close</mat-icon></a>
                    }@else {
                    <img src="assets/images/upload.svg" class="img-fluid" alt="" />
                    <input accept=".pdf, .xls, .xlsx,.png, .jpeg" (change)="
                Global.onFileUploadedToBase64(
                  formGroup,
                  $event,
                  'documentData',
                  toastr,
                  [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'image/jpeg',
                    'image/png'
                  ],
                  'fileName'
                )
              " type="file" />
                    }
                </div>

            </th>
            <th rowspan="2" colspan="1" class="fit-wdth">
                <p class="text-center">BACK</p>
                <div class="row-img choose-file"
                    [class.is-invalid]="!Global.isInputValid(formGroup, 'documentDataBack')">
                    @if (formGroup.value?.fileNameBack) {
                    <p class="file-selected">
                        {{ formGroup.value?.fileNameBack ?? "File Selected" }}
                    </p>
                    <a matTooltip="Clear" (click)="clear(true)" class="remove-file"><mat-icon>close</mat-icon></a>
                    }@else {
                    <img src="assets/images/upload.svg" class="img-fluid" alt="" />
                    <input accept=".pdf, .xls, .xlsx,.png, .jpeg" (change)="
                Global.onFileUploadedToBase64(
                  formGroup,
                  $event,
                  'documentDataBack',
                  toastr,
                  [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'image/jpeg',
                    'image/png'
                  ],
                  'fileNameBack'
                )
              " type="file" />
                    }
                </div>
            </th>
            <th scope="col">
                DOC TYPE@if (Global.isInputRuleAvailable(formGroup, 'docType',
                'required')) { <span class="text-danger">*</span>}
            </th>
            <th scope="col">
                DOC NUMBER@if (Global.isInputRuleAvailable(formGroup, 'docNumber',
                'required')) { <span class="text-danger">*</span>}
            </th>
            <th scope="col">
                ISSUED ON@if (Global.isInputRuleAvailable(formGroup, 'issuedOn',
                'required')) { <span class="text-danger">*</span>}
            </th>
            <th scope="col">
                VALID TILL@if (Global.isInputRuleAvailable(formGroup, 'validTill',
                'required')) { <span class="text-danger">*</span>}
            </th>
            <th rowspan="2" colspan="1" class="brder-left">
                <div class="cross-check-all">
                    <button (click)="resetForm()">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                    <button (click)="saveDoc()">
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
                </div>
            </th>
        </tr>
        <tr>
            <td class="clndr-img type">
                <select class="" formControlName="docType" (change)="onDocTypeChange()"
                    [class.is-invalid]="!Global.isInputValid(formGroup, 'docType')" aria-label="Default select example">
                    <option value="">Select</option>
                    <option value="PAN">PAN</option>
                    <option value="AADHAAR">AADHAAR</option>
                    <option value="EPIC">EPIC</option>
                    <option value="OTHERS">OTHERS</option>
                </select>
                @if (formGroup.value.docType=="OTHERS") {
                <input type="text" placeholder="Type Here" class="my-1" formControlName="othersName"
                    [class.is-invalid]="!Global.isInputValid(formGroup, 'othersName')" />
                }
            </td>

            <td class="clndr-img type">
                <input type="text" placeholder="Type Here" formControlName="docNumber"
                    [class.is-invalid]="!Global.isInputValid(formGroup, 'docNumber')" />
            </td>
            <td class="clndr-img type">
                <input type="date" formControlName="issuedOn"
                    [class.is-invalid]="!Global.isInputValid(formGroup, 'issuedOn')" />
            </td>
            <td class="clndr-img type">
                <input type="date" formControlName="validTill"
                    [class.is-invalid]="!Global.isInputValid(formGroup, 'validTill')" />
            </td>
        </tr>
    </table>
</div> -->